const circles = () => {
    const wrapper = document.querySelector('.mission-about__right');

    if (wrapper) {
        const items = wrapper.querySelectorAll('.mission-item');

        function applyPositions() {
            const vw = window.innerWidth;

            if (vw >= 681 && vw < 1440) {
                const size = items[0]?.offsetWidth || 0;
                if (size === 0) return;

                const offset     = size * 0.85;
                const totalWidth = size + offset * (items.length - 1);
                const startX     = (wrapper.offsetWidth - totalWidth) / 2;

                items.forEach((item, i) => {
                    item.style.setProperty('--target-x', `${startX + offset * i}px`);
                });
            } else {
                const defaultSize = items[0]?.offsetWidth || 0;
                if (defaultSize === 0) return;

                items.forEach((item, i) => {
                    item.style.setProperty('--target-x', `${defaultSize * 0.85 * i}px`);
                });
            }
        }

        window.addEventListener('load', () => {
            applyPositions();
        });

        window.addEventListener('resize', applyPositions);

        const resizeObserver = new ResizeObserver(() => {
            applyPositions();
        });

        items.forEach((item) => resizeObserver.observe(item));
        resizeObserver.observe(wrapper);

        applyPositions();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    wrapper.classList.add('animated');
                    observer.disconnect();
                }
            });
        }, { threshold : 0.3 });

        observer.observe(wrapper);
    }
};

export default circles;
